import React from "react";
import { Button } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import { MedicationGroup } from "components";
import { useCurrentCase } from "duck";
import {
  useCreateFluidBolus,
  useDeleteFluidBolus,
  useUpdateFluidBolus
} from "./duck";

const FluidBolus: React.FC = () => {
  const fluidBolus = useCurrentCase(
    ({ data }) => data.client.patient.fluidBolus
  );
  const update = useUpdateFluidBolus();
  const { create, loading } = useCreateFluidBolus();
  const deleteMedication = useDeleteFluidBolus();

  return (
    <MedicationGroup.Provider update={update}>
      <MedicationGroup
        groupName="Fluid Bolus"
        medications={
          fluidBolus ? [{ ...fluidBolus, medication: "Fluid Bolus" }] : []
        }
        create={
          <Button
            disabled={!!fluidBolus}
            isLoading={loading}
            leftIcon={<IoAdd />}
            onClick={create}
          >
            Add
          </Button>
        }
        onDelete={deleteMedication}
        medicationType="fluidBolus"
        expandedCards={false}
        doseUnit="mLs"
      />
    </MedicationGroup.Provider>
  );
};

export default FluidBolus;
